import { COOKIE_CLIENT_DASHBOARD_QUESTIONS } from '@/_constants/cookies';
import {
  getCookie,
  setCookie,
  type CookieValueTypes,
} from 'cookies-next/client';

export const getCardStatus = (questionnaireId: number): boolean => {
  const cookie: CookieValueTypes = getCookie(COOKIE_CLIENT_DASHBOARD_QUESTIONS);

  if (!cookie || typeof cookie !== 'string') return false;

  try {
    const cookieParsed = JSON.parse(cookie);

    if (!(questionnaireId in cookieParsed)) {
      return false;
    }

    return Boolean(cookieParsed[questionnaireId]);
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const toggleCardMore = (questionnaireId: number) => {
  if (!questionnaireId) return;

  const cookie: CookieValueTypes = getCookie(COOKIE_CLIENT_DASHBOARD_QUESTIONS);
  let status = { [questionnaireId]: true };

  try {
    const cookieParsed = !!cookie ? JSON.parse(cookie) : {};
    cookieParsed[questionnaireId] = !cookieParsed[questionnaireId];

    status = cookieParsed;
  } catch (error) {
    console.error(error);
  } finally {
    setCookie(COOKIE_CLIENT_DASHBOARD_QUESTIONS, status);
  }
};
